
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  onlineUsers: [],
  recipient: null
};

const userSlice = createSlice({
  name: "chatUser",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setRecipient: (state, action) => {
      state.recipient = action.payload;
    },
    setOnlineUsers: (state, action) => {
      state.onlineUsers = action.payload;
    },
    updatePresence: (state, action) => {
      const { userId, status } = action.payload;
      const user = state.onlineUsers.find(u => u.userId === userId);
      if (user) user.status = status;
    }
  }
});

export const { setCurrentUser, setOnlineUsers, updatePresence, setRecipient } = userSlice.actions;
export default userSlice.reducer;
